import * as React from 'react';
import { useEffect,useState,useRef } from 'react';
import { Helmet } from 'react-helmet';
import FaceService from '../services/face.service';
import TagSearchService from '../services/tagSearch.service';
import FaceComponent from '../components/FaceMatch.Component';
import {IFaceMatch } from '../@types/FaceMatch';
import {IsFaceMatch} from '../helpers/checkIsType';
import { handleHttpError } from '../helpers/HttpErrorHandler';

const TagSearch:React.FC = () => {
    const ref = useRef<HTMLInputElement>(null); 
    const loadMoreSteps = 50;
    const firstLoadNum = loadMoreSteps;
    const loadMoreMax = firstLoadNum + (loadMoreSteps * 2);

    const [showLatest, setShowLatest] = useState<boolean>(true);
    const [isMore, setIsMore] = useState<boolean>(false);
    const [loadMoreNum, setloadMoreNum] = useState<number>(firstLoadNum);
    const [loading, setLoading] = useState<boolean>(false);
    const [errorMsg, setErrorMsg] = useState<string>("");
    const [faces,popFaceData] = React.useState<IFaceMatch[]>([]);
    const [searchString, setSearchString] = useState("");//latina big tits blue eyes
    const [isNameSearch, setIsNameSearch] = useState<boolean>(true);
    const [searchPlaceholder, setSearchPlaceholder] = useState<string>('e.g. AnitaVega');

    const [tags,popTags] = React.useState<string[]>([]);
    const [showTags, setShowTags] = useState<boolean>(false);

    const faceService = FaceService.getInstance();
    const tagSearchService = TagSearchService.getInstance();

  useEffect(()=>{ 
      document.title = 'Camgirl model name search engine';
      let descMeta=document.querySelector("meta[name='description']");
      if(descMeta!==null)descMeta.setAttribute("content", 'Camgirl model finder with our model name search engine. Search and find camgirls using model names with our camgirl engine search.');
      //let canNAme=document.querySelector("link[rel='canonical']");
      //if(canNAme!==null)canNAme.setAttribute("href", 'https://www.camgirlcrawler.net/camgirl-name-search');

      getLatestFaces();

      }, []); // empty array means only once

  const handleSubmit = (event:any) => {
        event.preventDefault();
        reset();
        setShowTags(false);
        tagSearch(0,firstLoadNum);
      }

  const loadMore = (event:any) => {
        event.preventDefault();
        tagSearchLoadMore(loadMoreNum , loadMoreSteps);
      }

       
  const tagSearch = (skip: number, take: number) => {

        setErrorMsg("");
        setloadMoreNum(firstLoadNum);
        setIsMore(false);
        setLoading(true);

        if(searchString === '')
        {
            reset();
           //getLatestFaces();
            return;
        }

        tagSearchService.getTagSearchResults(searchString,skip,take,isNameSearch).then(response => { 
          if(response.length >0 && IsFaceMatch(response[0])){
              if(response[response.length-1].name === "==")
              {
                setIsMore(true);
                response.pop();
              }else
                setIsMore(false);
              popFaceData(response);
           }else{
              setErrorMsg(handleHttpError(response));
           } 
        }).catch(error => {
          setErrorMsg(handleHttpError(500));
          //console.log(error)
          console.clear();
        }).then(() =>{
              setLoading(false);
        });
      }

  const tagSearchLoadMore = (skip: number, take: number) => {

        if(loadMoreNum >= loadMoreMax) return;

        setLoading(true);

        tagSearchService.getTagSearchResults(searchString,skip,take,isNameSearch).then(response => {         
          if(response.length>0 && IsFaceMatch(response[0])){
            if(response[response.length-1].name === "==")
              {
                setIsMore(true);
                response.pop();
              }else
                setIsMore(false);

            var existingFaceData = faces;
            var newArray = existingFaceData.concat(response);
            popFaceData(newArray);
            if(response.length >= loadMoreSteps)
                  setloadMoreNum(loadMoreNum + loadMoreSteps);
            else
                setloadMoreNum(loadMoreMax);
          }else{
            setIsMore(false);
          } 
        }).catch(error => {
          setErrorMsg(handleHttpError(500));
          //console.log(error)
          console.clear();
        }).then(() =>{
              setLoading(false);
        });
  }


  const getLatestFaces = () =>
            {
                setShowLatest(true);
                      faceService.getLatestFaces().then(response => { 
                        if(response.length >0 && IsFaceMatch(response[0])){
                          popFaceData(response.slice(0, 15));
                          }else{
                            popFaceData([]);
                          } 
                        }).catch(error => {
                            popFaceData([]);
                        }).then(() =>{
                            setLoading(false);
                });
              }
const clearSearch = () => {
        reset();
        setSearchString('');
    }

  const reset = () => {
        setLoading(false);
        setShowLatest(false);
        popFaceData([]);
        setIsMore(false);
        setErrorMsg('');
    }

    return (
        <div>
              <Helmet>
                <script src="https://ecdwm.com/embed/lf?c=object_container&site=jasmin&cobrandId=&psid=camgirlcrawler&pstool=202_1&psprogram=revs&campaign_id=&category=girl&forcedPerformers[]=&preferredPerformers[]=Violeta&preferredPerformers[]=SelenaVoss&preferredPerformers[]=Gia&preferredPerformers[]=AnneRoss&preferredPerformers[]=DonnaTaylor&preferredPerformers[]=MelaniePardo&preferredPerformers[]=VenusRusell&vp[showChat]=true&vp[chatAutoHide]=true&vp[showCallToAction]=&vp[showPerformerName]=true&vp[showPerformerStatus]=true&ms_notrack=1&subAffId=" defer></script>  
              </Helmet> 
      
            <section>
            <div className='pageHeader'>
              <h1>Camgirl model name search</h1>
              <div><b><i>Search and find your favourite camgirl models agian!</i></b></div>
            </div>
            <div className='info' id='info'>
                Welcome to our camgirl name search engine. 
                To find camgirl models by their model name enter the model's perfomer name and press the 'Start Search' button. 
                Camgirl name search returns all camgirl's with the same or similar perfomer names.
                Search results are always returned by the the closet name matched and then 'last seen' models first. 
          </div>
      </section>
            <form onSubmit={handleSubmit} className="searchBox">
            <div className="input-group">
              <input ref={ref}  className="form-control" value={searchString} placeholder={searchPlaceholder} onChange={(e) => setSearchString(e.target.value)} style={{fontSize:'1.25rem',color:'#626163', background:'white'}}/>
              <span className="input-group-addon" style={{width:'15%'}}>
                  <button id="nameSearchBtn" className="btn" style={{background:'#E0E0E0'}} onClick={handleSubmit}>
                  <img src={'images/search.gif'} alt="Start Search" title="Start Search" width={20} height={20} style={{cursor:'pointer'}}/>
                  </button>
                  <div className='clearTagSearch' hidden={searchString===''} onClick={clearSearch}>X</div>
              </span>
            </div>
            </form>
            <div className='cgod_container' hidden={!showLatest}>
                <div className='cgod'>
                  <h2 style={{textDecoration:'underline'}}>Camgirl of the day!</h2>
                  <div id="object_container" style={{width:'100%',height:'100%',marginTop:'30px'}}></div>
                </div>
            </div>
          <div style={{minHeight:'750px',marginTop:'60px'}}>
                <h2 style={{paddingTop:'20px'}} hidden={!showLatest || faces.length==0}>Latest camgirls added for name search:</h2>
                <div className='resultsThumbsOutter'>
                  {faces.length>0 && faces.map((face: IFaceMatch) => (
                    <FaceComponent key={face.name}  face={face} imgWidth='250' imgHeight='250'/>
                        ))    
                    } 
                </div>         
            {loading && faces.length===0 &&(      
              <div style={{padding:'30px'}}>                 
                  <img src={'images/spinner.gif'} alt="Loading" height={'25px'} width={'25px'}/>
              </div>  
            )}     
            {errorMsg && (
              <div className="alert alert-danger errorMessage" role="alert" style={{marginTop:'30px'}}>
                {errorMsg}
              </div>
              )}
            {!errorMsg && isMore && loadMoreNum < loadMoreMax && (
            <div style={{margin:'30px'}}>
            <button
                  className="btn btn-success"
                  onClick={loadMore}>
                   Show More
                </button>
            </div> 
            )} 
          <div>{loading && faces.length > 0 && loadMoreNum < loadMoreMax && (                                            
                  <img src={'images/spinner.gif'} alt="Loading"  width={'25px'}/>
                  )}
          </div>
          </div>
          <div className='info' style={{marginTop:'40px'}}>
            <section>
              <h4>What we do:</h4>
              <br/>
                    <div style={{textAlign:'center',width:'100%',margin:'auto'}}>
                        <span className="dot"/>Crawl popular camgirl model plaforms new models<br/>
                        <span className="dot"/>Retain a camgirl model's details for up to six months for searches<br/>            
                        <span className="dot"/>Current & previous performer name matching for camgirl model's<br/>
                        <span className="dot"/>Show only face or profile images of camgirl's returned in searches<br/>
                        <span className="dot"/>Provide a tag and name search engine for finding camgirl model's<br/>
                        <span className="dot"/>Link to a camgirl model account found in a name or tag search<br/>
                        <span className="dot"/>Work with camgirl model plaforms as an affiliate<br/>
                        <span className="dot"/>Respect camgirl model's privacy<br/>
                        <span className="dot"/>Respect your (the user's) privacy<br/>
                    </div>    
            </section>
          </div>
          <div className='info' style={{marginTop:'30px'}}>
            <section>
              <h4>What we don't do:</h4>
              <br/>
                    <div style={{textAlign:'center',width:'100%',margin:'auto'}}>
                        <span className="dot"/>Post the real name of camgirl models<br/>
                        <span className="dot"/>Retain camgirl model's details beyond six months if not seen in crawls<br/>
                        <span className="dot"/>Show any images of a camgirl model performing<br/>
                        <span className="dot"/>Show recorded videos of a camgirl model performing<br/>
                        <span className="dot"/>Find a camgirl model's real social media accounts<br/>
                        <span className="dot"/>Charge for our camgirl model search service<br/>
                        <span className="dot"/>Retain any of your (the user's) usage details<br/>            
                    </div>    
            </section>
          </div>                      
        </div>
  );
}
export default TagSearch;